import {
  Image,
  Card,
  Button,
  Typography,
  theme,
  Flex,
  Row,
  Col,
  List,
  Grid,
  Form,
  Checkbox,
  Input,
  Select,
  Space,
} from "antd";
import { Content } from "antd/es/layout/layout";
import { BankOutlined, IdcardOutlined, LockOutlined } from "@ant-design/icons";

import imgv1 from "assets/images/v1.svg";
import imgv2 from "assets/images/v2.svg";
import imgv3 from "assets/images/v3.svg";
import imgv4 from "assets/images/v4.svg";
import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
const { Title, Text } = Typography;
const { useToken } = theme;

function RegisterComponent() {
  const {
    token: { colorPrimary },
  } = useToken();

  const [form] = Form.useForm();

  type LayoutType = Parameters<typeof Form>[0]["layout"];

  type SizeType = Parameters<typeof Form>[0]["size"];
  const [componentSize, setComponentSize] = useState<SizeType | "default">(
    "default"
  );
  const variant = Form.useWatch("variant", form);

  const onContinueCheck = (e: any) => {
    console.log(`checked = ${e.target.checked}`);
  };
  return (
    <Content>
      <div>
        <div className="top-header py-5">
          <div className="container">
            <Typography.Title level={1} className="text-center mb-0 mt-0">
              Agent &nbsp;
              <Text type="danger" className="header-font-title">
                Registration
              </Text>
            </Typography.Title>

            <Text type="secondary" className="text-center d-block">
              Hello, Welcome to our B2B Website - especially designed for our
              Agents..! <br />
              Now you can book various range of products with us & sell to your
              customers. We will go hand-in-hand to follow the simple principle
              of Sell More & Earn More. Get registered with us today & we will
              assist you all the way from start to end. We will be happy to
              connect with you..!
            </Text>
          </div>
        </div>

        <div className="container">
          <Row gutter={[16, 16]} className="mt-5">
            <Col xs={24} sm={24} md={16} lg={16}>
              <Card
                className="annulment-card border-radius-20 p-4 light-sky-color"
                bordered
              >
                <Form
                  layout="vertical"
                  initialValues={{ variant: "filled", size: componentSize }}
                  variant={variant || "filled"}
                  form={form}
                  size={"large"}
                  className="twoColumnInput"
                >
                  <Typography.Title
                    level={4}
                    className="mb-2 mt-0 d-block w-100"
                  >
                    <BankOutlined /> Company Details
                  </Typography.Title>

                  <Form.Item
                    label="Travel Agency Name"
                    required
                    className="mb-0"
                  >
                    <Input placeholder="Travel Agency Name" />
                  </Form.Item>
                  <Form.Item label="Address" required className="mb-0">
                    <Input placeholder="input placeholder" />
                  </Form.Item>
                  <Form.Item label="Website" className="mb-0">
                    <Input placeholder="Travel Agency Name" />
                  </Form.Item>
                  <Form.Item label="Select Country" required className="mb-0">
                    <Select>
                      <Select.Option value="demo">Demo</Select.Option>
                    </Select>
                  </Form.Item>
                  <Form.Item label="Select City" required className="mb-0">
                    <Select>
                      <Select.Option value="demo">Demo</Select.Option>
                    </Select>
                  </Form.Item>
                  <Form.Item label="Zip Code" required className="mb-0">
                    <Input placeholder="input placeholder" />
                  </Form.Item>

                  <Typography.Title
                    level={4}
                    className="mb-2 mt-4 d-block w-100"
                  >
                    <IdcardOutlined /> Profile Details
                  </Typography.Title>

                  <Form.Item label="Agent Name" required className="mb-0">
                    <Input placeholder="Agent Name" />
                  </Form.Item>
                  <Form.Item label="Mobile Number" required>
                    <Space.Compact className="w-100">
                      <Form.Item name={["address", "street"]} noStyle>
                        <Input
                          style={{
                            width: "50%",
                          }}
                          placeholder="Code"
                        />
                      </Form.Item>
                      <Form.Item
                        name={["address", "province"]}
                        noStyle
                        rules={[
                          {
                            required: true,
                            message: "Province is required",
                          },
                        ]}
                      >
                        <Input placeholder="Mobile Number" />
                      </Form.Item>
                    </Space.Compact>
                  </Form.Item>

                  <Form.Item label="Telephone Number" required>
                    <Space.Compact className="w-100">
                      <Form.Item name={["address", "street"]} noStyle>
                        <Input
                          style={{
                            width: "50%",
                          }}
                          placeholder="Code"
                        />
                      </Form.Item>
                      <Form.Item
                        name={["address", "province"]}
                        noStyle
                        rules={[
                          {
                            required: true,
                            message: "Province is required",
                          },
                        ]}
                      >
                        <Input placeholder="Mobile Number" />
                      </Form.Item>
                    </Space.Compact>
                  </Form.Item>

                  <Form.Item label="Email" required className="mb-0">
                    <Input placeholder="Email" />
                  </Form.Item>
                  <Form.Item label="Confirm Email" className="mb-0">
                    <Input placeholder="Confirm Email" />
                  </Form.Item>
                  <Form.Item
                    label="Preferred Currency"
                    required
                    className="mb-0"
                  >
                    <Select>
                      <Select.Option value="demo">Demo</Select.Option>
                    </Select>
                  </Form.Item>
                  <Form.Item
                    label="Preferred Designation"
                    required
                    className="mb-0"
                  >
                    <Select>
                      <Select.Option value="demo">Demo</Select.Option>
                    </Select>
                  </Form.Item>
                  <Form.Item label="Skype Id" required className="mb-0">
                    <Input placeholder="Skype Id" />
                  </Form.Item>
                  <Form.Item label="Whatsapp Number" required className="mb-0">
                    <Input placeholder="Whatsapp Number" />
                  </Form.Item>

                  <Typography.Title
                    level={4}
                    className="mb-2 mt-4 d-block w-100"
                  >
                    <LockOutlined /> Password Setting
                  </Typography.Title>

                  <Form.Item label="User Number" required className="mb-0">
                    <Input placeholder="User Number" />
                  </Form.Item>

                  <Form.Item label="Password" required className="mb-0">
                    <Input placeholder="Password" />
                  </Form.Item>

                  <Form.Item label="Confirm Password" required className="mb-0">
                    <Input placeholder="Confirm Password" />
                  </Form.Item>

                  <Checkbox onChange={onContinueCheck} className="w-100 py-3">
                    By continuing, you agree to the
                    <Button
                      type="link"
                      href={"/privacy-policy"}
                      className="p-0"
                    >
                      Terms and Conditions & Privacy Policy
                    </Button>
                  </Checkbox>
                  <Form.Item>
                    <Button type="primary" className="px-5">
                      SIGN UP
                    </Button>
                  </Form.Item>
                </Form>
              </Card>
            </Col>

            <Col xs={24} sm={24} md={8} lg={8}>
              <Card className="annulment-card border-radius-20  p-4" bordered>
                <List itemLayout="horizontal" className="list-view-register">
                  <List.Item>
                    <List.Item.Meta
                      avatar={<img src={imgv1} />}
                      title={
                        <Typography.Text>
                          {"Free & Quick Registration"}
                        </Typography.Text>
                      }
                    />
                  </List.Item>
                  <List.Item>
                    <List.Item.Meta
                      avatar={<img src={imgv4} />}
                      title={
                        <Typography.Text>
                          {"Build your Own Package"}
                        </Typography.Text>
                      }
                    />
                  </List.Item>
                  <List.Item>
                    <List.Item.Meta
                      avatar={<img src={imgv3} />}
                      title={
                        <Typography.Text>
                          {"Online settlement of Invoice & Receipts"}
                        </Typography.Text>
                      }
                    />
                  </List.Item>
                  <List.Item>
                    <List.Item.Meta
                      avatar={<img src={imgv2} />}
                      title={
                        <Typography.Text>
                          {"Create your Sub Agents"}
                        </Typography.Text>
                      }
                    />
                  </List.Item>

                  <List.Item>
                    <List.Item.Meta
                      avatar={<img src={imgv2} />}
                      title={
                        <Typography.Text>
                          {"Strong Mark-up module"}
                        </Typography.Text>
                      }
                    />
                  </List.Item>

                  <List.Item>
                    <List.Item.Meta
                      avatar={<img src={imgv2} />}
                      title={
                        <Typography.Text>
                          {"Live Inventory of products"}
                        </Typography.Text>
                      }
                    />
                  </List.Item>

                  <List.Item>
                    <List.Item.Meta
                      avatar={<img src={imgv2} />}
                      title={
                        <Typography.Text>
                          {"Add to Favorite list"}
                        </Typography.Text>
                      }
                    />
                  </List.Item>

                  <List.Item>
                    <List.Item.Meta
                      avatar={<img src={imgv2} />}
                      title={
                        <Typography.Text>
                          {
                            "Multiple Tour options, Transfer options & time slots for the same tour"
                          }
                        </Typography.Text>
                      }
                    />
                  </List.Item>
                  <List.Item>
                    <List.Item.Meta
                      avatar={<img src={imgv2} />}
                      title={
                        <Typography.Text>
                          {"Shopping Cart application"}
                        </Typography.Text>
                      }
                    />
                  </List.Item>
                  <List.Item>
                    <List.Item.Meta
                      avatar={<img src={imgv2} />}
                      title={
                        <Typography.Text>
                          {"Get relaxed with instant confirmation on bookings"}
                        </Typography.Text>
                      }
                    />
                  </List.Item>
                </List>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </Content>
  );
}

export default RegisterComponent;
